<template>
  <div class="download">
    <div v-for="(item, i) in downloadList" :key="i">
      <a
        target="_blank"
        class="download_box"
        :href="item.url"
        @click="track(item.trackDevice)"
      >
        <img class="download_box" :src="ptDownloadImage(item.imageUrl)" />
      </a>
    </div>
  </div>
</template>
<script>
import { checkPlatform } from "../configs/download";
import { uploadTrack } from "../configs/userStatsTrack";
import siteType from "../configs/siteType";
import { globalConfigMixin } from "../mixin/globalConfig";
import Store from "@/store.js";
import { mapState } from "vuex";
export default {
  mixins: [globalConfigMixin],
  props: {
    isOlakk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      downloadCheck: false,
      openAll: false,
      // downloadList: [],
      siteType,
    };
  },
  computed: {
    downloadLink() {
      return Store.state.downloadLink
    },
    APPLE_DOWNLOAD() {
      return this.downloadLink.apple;
    },
    ANDROID_DOWNLOAD() {
      return this.downloadLink.android;
    },
    WINDOWS_DOWNLOAD() {
      return this.downloadLink.windows;
    },
    MAC_DOWNLOAD() {
      return this.downloadLink.mac;
    },
    WEB_DOWNLOAD() {
      return this.downloadLink.web;
    },
    downloadList() {
      const res = JSON.parse(localStorage.getItem("legal"));

      const blockList = this.globalConfig.andriodOnly; // android
      const checkObj = checkPlatform(res.platform, blockList);
      const isMac = /Macintosh|Mac OS X/i.test(navigator.userAgent);
      const defaultList = [
        // android, apple
        {
          url: this.ANDROID_DOWNLOAD,
          trackDevice: "Android",
          imageUrl: "/static/img/download_btn/download_android.svg",
        },
        isMac
          ? {
              url: this.MAC_DOWNLOAD,
              trackDevice: "Mac",
              imageUrl: "/static/img/download_btn/download_macos.svg",
            }
          : {
              url: this.WINDOWS_DOWNLOAD,
              trackDevice: "Windows",
              imageUrl: "/static/img/download_btn/download_windows.svg",
            },
      ];

      if (siteType.GetSiteType() != siteType.SITE_TYPE_NUTS) {
        if (["Malaysia", "South Korea"].includes(res.platform)) {
          let appleBtn = {
            url: "",
            trackDevice: "iPhone",
            imageUrl: "/static/img/download_btn/download_for_iOS.png",
          };
          switch (res.platform) {
            case "Malaysia":
              appleBtn.url = "https://kkpoker.net/download-kkpoker-app-on-ios/";
              break;
            case "South Korea":
              appleBtn.url =
                "https://kkpoker.co/pt/download-kkpoker-app-on-ios/";
              break;
            case "Malta":
            case "Greece":
            case "Belgium":
              appleBtn.url =
                "https://kkpoker.world/download-kkpoker-app-on-ios/";
              break;
          }
          defaultList.push(appleBtn);
        } else if (checkObj.iphone) {
          defaultList.push({
            url: this.APPLE_DOWNLOAD,
            trackDevice: "iPhone",
            imageUrl: "/static/img/download_btn/download_app_store.svg",
          });
        }
      } else {
        if (checkObj.iphone) {
          defaultList.push({
            url: this.APPLE_DOWNLOAD,
            trackDevice: "iPhone",
            imageUrl: "/static/img/download_btn/download_app_store.svg",
          });
        }
      }

      if (checkObj.web) {
        defaultList.push({
          url: this.WEB_DOWNLOAD,
          trackDevice: "Web",
          imageUrl: "/static/img/download_btn/download_browser.svg",
        });
      }

      return defaultList;
    },
  },
  mounted() {
    const res = JSON.parse(localStorage.getItem("legal"));
    this.$root.currentType = res.currentType;
    this.$emit("setPlatform", res.platform);
    // TODO: test
    // res.platform='Norway'
  },
  methods: {
    track(deviceType) {
      const specialStr = this.isOlakk ? " Special" : "";
      const category = `SignUp${specialStr} PC`;
      this.$gtag.event("Click", {
        event_category: category,
        event_label: `Download ${deviceType}`,
      });
      // upload track data to aliyun
      uploadTrack(this);
    },
    ptDownloadImage(src) {
      const isApple = src.includes("app_store");
      if (!isApple && this.$i18n.locale === "pt") {
        return src.replace(".png", "_pt.png");
      }
      return src;
    },
  },
};
</script>
<style lang="less" scoped>
.download {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  a img {
    &.download_box {
      margin: 10px 15px;
      width: 3.55rem !important;
    }
  }
}
</style>
